(function () {
  'use strict';

  if (window.RuckstuhlMarket && window.RuckstuhlMarket.version) return;

  const dataNode = document.getElementById('RuckstuhlMarketData');
  const OBSERVE_PRICES = window.RuckstuhlMarketObservePrices !== false;
  let data = {};
  try { data = JSON.parse(dataNode ? dataNode.textContent : '{}'); } catch (error) { data = {}; }

  const BASE_CURRENCY = String(data.base_currency || 'CHF').toUpperCase();
  let BASE_VAT_RATE = Number(data.base_vat_rate || 8.1) / 100;
  const STORAGE_KEY = String(data.storage_key || 'ruckstuhl_price_country');
  const STORAGE_SOURCE_KEY = String(data.storage_source_key || 'ruckstuhl_price_country_source');
  const DEFAULT_COUNTRY = String(data.default_country || 'CH').toUpperCase();
  const AUTO_DETECT = data.auto_detect_country !== false;
  const EXTERNAL_GEO_FALLBACK = data.external_geo_fallback !== false;
  const EXTERNAL_GEO_ENDPOINT = String(data.external_geo_endpoint || 'https://api.country.is/');
  const I18N = data.i18n && typeof data.i18n === 'object' ? data.i18n : {};
  const metaobjectMarkets = Array.isArray(data.markets) ? data.markets : [];
  /* Das Metaobjekt ist die einzige verbindliche Preisland-Datenquelle. */
  const rawMarkets = metaobjectMarkets;
  const marketDataSource = 'metaobject';
  const NBSP = '\u00A0';

  function number(value, fallback) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    const parsed = Number(String(value == null ? '' : value).trim().replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function bool(value) {
    return value === true || value === 1 || String(value).toLowerCase() === 'true';
  }

  function locale() {
    return String(document.documentElement.lang || 'de-CH').replace('_', '-');
  }

  function translate(key, replacements) {
    let output = String(I18N[key] == null ? key : I18N[key]);
    Object.keys(replacements || {}).forEach(function (name) {
      output = output.replace(new RegExp('{{\\s*' + name + '\\s*}}', 'g'), String(replacements[name]));
    });
    return output;
  }

  function localizedNumber(value, minimum, maximum) {
    try {
      return new Intl.NumberFormat(locale(), {
        minimumFractionDigits: minimum == null ? 0 : minimum,
        maximumFractionDigits: maximum == null ? 2 : maximum
      }).format(number(value, 0));
    } catch (error) {
      return number(value, 0).toFixed(maximum == null ? 2 : maximum);
    }
  }

  function inferTaxType(market) {
    const explicit = String(market.tax_type || '').trim();
    if (explicit) return explicit;
    const source = String(market.vat_text || '');
    if (/\bIGI\b/i.test(source)) return 'IGI';
    if (/monofase/i.test(source)) return 'Monofase';
    return translate('vat_short');
  }

  const markets = rawMarkets.map(function (market) {
    const mode = String(market.tax_calculation_mode || 'fixed').toLowerCase();
    const rate = number(market.vat_rate, 0);
    return {
      country_code: String(market.country_code || '').toUpperCase(),
      country_name: String(market.country_name || market.country_code || ''),
      currency_code: String(market.currency_code || BASE_CURRENCY).toUpperCase(),
      currency_factor: number(market.currency_factor, 1) || 1,
      market_price_factor: number(market.market_price_factor, 1) || 1,
      tax_calculation_mode: mode,
      vat_rate: rate,
      tax_type: inferTaxType(market),
      raw_vat_text: String(market.vat_text || ''),
      price_text: String(market.price_text || ''),
      dealer_text: String(market.dealer_text || ''),
      note: String(market.note || ''),
      localized_fields: bool(market.localized_fields),
      rounding_step: number(market.rounding_step, 0.01) || 0.01,
      is_fallback: bool(market.is_fallback),
      active: market.active == null ? true : bool(market.active)
    };
  }).filter(function (market) { return market.active && market.country_code; });

  if (!markets.length) {
    console.error('[Ruckstuhl Preisland] Keine aktiven Einträge im Metaobjekt "' + String(data.metaobject_type || '') + '" gefunden.');
    return;
  }

  const fallbackMarket = markets.find(function (market) { return market.is_fallback; })
    || markets.find(function (market) { return market.country_code === 'INTERNATIONAL'; })
    || markets.find(function (market) { return market.country_code === 'CH'; })
    || markets[0];
  const swissMarket = markets.find(function (market) { return market.country_code === 'CH'; });
  if (swissMarket && swissMarket.vat_rate > 0) BASE_VAT_RATE = swissMarket.vat_rate / 100;

  const marketMap = new Map(markets.map(function (market) { return [market.country_code, market]; }));
  if (!marketMap.has(fallbackMarket.country_code)) marketMap.set(fallbackMarket.country_code, fallbackMarket);

  function storageGet(key) {
    try { return String(window.localStorage.getItem(key) || ''); } catch (error) { return ''; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, String(value)); } catch (error) {}
  }

  const storedCode = storageGet(STORAGE_KEY).toUpperCase();
  const storedSource = storageGet(STORAGE_SOURCE_KEY).toLowerCase();
  let selectedCode = marketMap.has(storedCode)
    ? storedCode
    : (marketMap.has(DEFAULT_COUNTRY) ? DEFAULT_COUNTRY : fallbackMarket.country_code);
  let selectionSource = marketMap.has(storedCode) ? (storedSource || 'saved') : 'default';
  let detectedCountryCode = selectionSource === 'auto' ? selectedCode : '';

  function current() {
    return marketMap.get(selectedCode) || fallbackMarket;
  }

  function countryDisplayName(market) {
    const selected = market || current();
    if (selected.is_fallback || selected.country_code === 'INTERNATIONAL') return translate('international');
    try {
      if (typeof Intl.DisplayNames === 'function' && /^[A-Z]{2}$/.test(selected.country_code)) {
        const display = new Intl.DisplayNames([locale()], { type: 'region' }).of(selected.country_code);
        if (display && display !== selected.country_code) return display;
      }
    } catch (error) {}
    return selected.country_name || selected.country_code;
  }


  function regionDisplayName(code) {
    const regionCode = String(code || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(regionCode)) return regionCode;
    try {
      if (typeof Intl.DisplayNames === 'function') {
        const display = new Intl.DisplayNames([locale()], { type: 'region' }).of(regionCode);
        if (display && display !== regionCode) return display;
      }
    } catch (error) {}
    return regionCode;
  }

  function round(value, step) {
    const size = number(step, 0.01) || 0.01;
    return Math.round((number(value, 0) + Number.EPSILON) / size) * size;
  }

  function includesTax(market) {
    return market.tax_calculation_mode === 'fixed' && market.vat_rate > 0;
  }

  function taxText(market) {
    const selected = market || current();
    if (selected.localized_fields && String(selected.raw_vat_text || '').trim()) {
      return String(selected.raw_vat_text).trim();
    }
    if (includesTax(selected)) {
      return translate('including_tax', {
        rate: localizedNumber(selected.vat_rate, Number.isInteger(selected.vat_rate) ? 0 : 1, 2),
        tax: selected.tax_type || translate('vat_short')
      });
    }
    if (selected.tax_calculation_mode === 'variable') return translate('variable_tax');
    return translate('excluding_tax');
  }

  function recommendedPriceText(market) {
    const selected = market || current();
    if (selected.localized_fields && String(selected.price_text || '').trim()) {
      return String(selected.price_text).trim();
    }
    return translate('recommended_price');
  }

  function dealerText(market) {
    const selected = market || current();
    if (selected.localized_fields && String(selected.dealer_text || '').trim()) {
      return String(selected.dealer_text).trim();
    }
    return translate('dealer_note');
  }

  function convertNetExclusive(netChf, market) {
    const selected = market || current();
    const netLocal = number(netChf, 0) * selected.currency_factor * selected.market_price_factor;
    return round(netLocal, selected.rounding_step);
  }

  function convertNet(netChf, market) {
    const selected = market || current();
    const netLocal = convertNetExclusive(netChf, selected);
    const total = includesTax(selected) ? netLocal * (1 + selected.vat_rate / 100) : netLocal;
    return round(total, selected.rounding_step);
  }

  function convertBaseGross(grossChf, market) {
    const netChf = number(grossChf, 0) / (1 + BASE_VAT_RATE);
    return convertNet(netChf, market);
  }

  function formatAmount(amount, currency, market, options) {
    const selected = market || current();
    const opts = options || {};
    const code = String(currency || selected.currency_code || BASE_CURRENCY).toUpperCase();
    const value = round(amount, selected.rounding_step);
    const formatted = localizedNumber(value, 2, 2);
    return opts.currencyPosition === 'after' ? (formatted + NBSP + code) : (code + NBSP + formatted);
  }

  function priceSuffix(market) {
    const selected = market || current();
    return taxText(selected) + (selected.country_code === 'CH' ? '' : ' · ' + recommendedPriceText(market));
  }

  function formatNet(netChf, options) {
    const opts = options || {};
    const selected = opts.market || current();
    const amount = convertNet(netChf, selected);
    const formatted = formatAmount(amount, selected.currency_code, selected, opts);
    return opts.withTaxText === false ? formatted : formatted + NBSP + priceSuffix(selected);
  }

  function formatGrossChf(grossChf, options) {
    const opts = options || {};
    const selected = opts.market || current();
    const amount = convertBaseGross(grossChf, selected);
    const formatted = formatAmount(amount, selected.currency_code, selected, opts);
    return opts.withTaxText === false ? formatted : formatted + NBSP + priceSuffix(selected);
  }

  function parseSwissNumber(value) {
    let text = String(value || '').replace(/[’'\s]/g, '');
    const lastComma = text.lastIndexOf(',');
    const lastDot = text.lastIndexOf('.');
    if (lastComma > lastDot) text = text.replace(/\./g, '').replace(',', '.');
    else text = text.replace(/,/g, '');
    const parsed = Number.parseFloat(text.replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  const priceRootSelector = [
    '[data-product-price]', '[data-unit-price]', '.grid-product__price', '.grid-product__price--original', '.grid-product__price--savings', '.product__unit-price', '.product__price', '[data-rk-net-price-cents]',
    '.art-rug-product__variant-price', '.rk-fixauswahl__card-price', '.rk-fixed-variant__card-price', '.rk-fixed-variant__sticky-price', '[data-rk-sticky-price]', '[data-tk-price]',
    '[data-tk-sticky-price]', '[data-tk-footer-price]', '[data-rk-at-footer-price]', '[data-rk-at-final-price]',
    '[data-rk-summary-price]', '[data-summary-price]', '[data-summary-m2-price]', '[data-sticky-price]',
    '[data-rk-rb-price]', '[data-price-display]', '[data-price]', '[id$="-price-total"]'
  ].join(',');

  const grossPriceRootSelector = [
    '[data-rk-price-source="gross"]', '[data-rk-sticky-price]', '[data-tk-price]', '[data-tk-sticky-price]',
    '[data-tk-footer-price]', '[data-rk-at-footer-price]', '[data-rk-at-final-price]', '[data-rk-summary-price]',
    '[data-summary-price]', '[data-summary-m2-price]', '[data-sticky-price]', '[data-rk-rb-price]', '[id$="-price-total"]'
  ].join(',');

  const registry = new Set();
  const exactRegistry = new Set();
  let rendering = false;

  function sourceIsGross(source, node) {
    if (/(?:exkl|excl)\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:mwst|mehrwertsteuer|vat|tva|iva|tax)/i.test(source)) return false;
    if (/(?:inkl|incl)\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:mwst|mehrwertsteuer|vat|tva|iva|tax)/i.test(source)) return true;
    const parent = node && node.parentElement;
    return !!(parent && parent.closest(grossPriceRootSelector));
  }

  function replaceTaxText(text, market, forceExclusive) {
    let output = text;
    const suffix = forceExclusive ? translate('excluding_tax') : priceSuffix(market);
    output = output.replace(/(?:inkl|incl)\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:mwst|mehrwertsteuer|vat|tva|iva|tax)/gi, suffix);
    output = output.replace(/(?:exkl|excl)\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:mwst|mehrwertsteuer|vat|tva|iva|tax)/gi, suffix);
    return output;
  }

  function transformPriceText(source, mode) {
    const market = current();
    const sourceText = String(source || '');
    const explicitExclusive = /(?:exkl|excl)\.?\s*(?:\d+(?:[.,]\d+)?\s*%\s*)?(?:mwst|mehrwertsteuer|vat|tva|iva|tax)/i.test(sourceText);
    const exclusiveDisplay = explicitExclusive && localStorage.getItem('rk_tax_display') === 'net';
    const grossSource = mode === 'gross';
    let transformed = sourceText.replace(/CHF\s*([0-9][0-9\s’'.,-]*)/gi, function (match, numeric) {
      const amount = parseSwissNumber(numeric);
      const local = grossSource ? convertBaseGross(amount, market) : (exclusiveDisplay ? convertNetExclusive(amount, market) : convertNet(amount, market));
      return formatAmount(local, market.currency_code, market);
    });
    transformed = transformed.replace(/([0-9][0-9\s’'.,-]*)\s*CHF\b/gi, function (match, numeric) {
      const amount = parseSwissNumber(numeric);
      const local = grossSource ? convertBaseGross(amount, market) : (exclusiveDisplay ? convertNetExclusive(amount, market) : convertNet(amount, market));
      return formatAmount(local, market.currency_code, market);
    });
    transformed = replaceTaxText(transformed, market, exclusiveDisplay);
    transformed = transformed
      .replace(/\b([A-Z]{3})\s*(?=(?:inkl|exkl|incl|excl)\.)/gi, '$1' + NBSP)
      .replace(/([0-9])\s*(?=(?:inkl|exkl|incl|excl)\.)/gi, '$1' + NBSP);
    return transformed;
  }

  function exactPriceMarkup(element) {
    const cents = number(element.getAttribute('data-rk-net-price-cents'), 0);
    const source = String(element.getAttribute('data-rk-price-source') || 'net').toLowerCase();
    const amount = source === 'gross' ? convertBaseGross(cents / 100) : convertNet(cents / 100);
    const position = String(element.getAttribute('data-rk-price-currency-position') || 'before');
    const prefixKey = String(element.getAttribute('data-rk-price-prefix-key') || '');
    const unitKey = String(element.getAttribute('data-rk-price-unit-key') || '');
    const prefix = prefixKey ? translate(prefixKey) + ' ' : '';
    const unit = unitKey ? ' ' + translate(unitKey) : '';
    return prefix + formatAmount(amount, current().currency_code, current(), { currencyPosition: position }) + unit;
  }

  function renderExactPriceElement(element) {
    if (!element || !element.getAttribute) return;
    exactRegistry.add(element);
    const desired = exactPriceMarkup(element);
    if (element.textContent !== desired) element.textContent = desired;
  }

  function normalizeTaxSpacingInNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const source = String(node.nodeValue || '');
    const normalized = source
      .replace(/([A-Z]{3})(?=(?:inkl|exkl|incl|excl)\.)/gi, '$1' + NBSP)
      .replace(/([0-9])(?=(?:inkl|exkl|incl|excl)\.)/gi, '$1' + NBSP)
      .replace(/([A-Z]{3}|[0-9])\s+(?=(?:inkl|exkl|incl|excl)\.)/gi, '$1' + NBSP);
    if (normalized !== source) node.nodeValue = normalized;
  }

  function normalizeTaxSpacingInElement(element) {
    if (!element) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) normalizeTaxSpacingInNode(node);
  }

  function registerTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const parent = node.parentElement;
    if (!parent || !parent.closest(priceRootSelector)) return;
    const tag = parent.tagName;
    if (/^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT|OPTION)$/.test(tag)) return;
    if (parent.closest('[data-rk-net-price-cents]')) return;
    const currentText = node.nodeValue || '';
    if (/CHF\s*[0-9]|[0-9][0-9\s’'.,-]*\s*CHF\b/i.test(currentText)) {
      node.__rkMarketSource = currentText;
      node.__rkMarketSourceMode = sourceIsGross(currentText, node) ? 'gross' : 'net';
    }
    normalizeTaxSpacingInNode(node);
    if (!node.__rkMarketSource) return;
    registry.add(node);
    const desired = transformPriceText(node.__rkMarketSource, node.__rkMarketSourceMode || 'net');
    if (node.nodeValue !== desired) node.nodeValue = desired;
  }

  function scan(root) {
    const scope = root && root.nodeType === 1 ? root : document.body;
    if (!scope) return;
    if (scope.matches && scope.matches('[data-rk-net-price-cents]')) renderExactPriceElement(scope);
    scope.querySelectorAll && scope.querySelectorAll('[data-rk-net-price-cents]').forEach(renderExactPriceElement);
    if (scope.matches && scope.matches(priceRootSelector)) {
      const walkerSelf = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      let nSelf;
      while ((nSelf = walkerSelf.nextNode())) registerTextNode(nSelf);
    }
    scope.querySelectorAll && scope.querySelectorAll(priceRootSelector).forEach(function (element) {
      normalizeTaxSpacingInElement(element);
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) registerTextNode(node);
    });
    if (scope.matches && scope.matches(priceRootSelector)) normalizeTaxSpacingInElement(scope);
    updateTaxNotes(scope);
    updatePurchaseAvailability(scope);
  }

  function updateTaxNotes(root) {
    const market = current();
    const noteText = taxText(market) + (market.country_code === 'CH' ? '' : ' · ' + recommendedPriceText(market));
    const scope = root && root.querySelectorAll ? root : document;
    const explicitNotes = scope.querySelectorAll ? scope.querySelectorAll('[data-rk-market-tax-note]') : [];
    explicitNotes.forEach(function (note) { note.textContent = noteText; });
    const containers = scope.querySelectorAll ? scope.querySelectorAll('.grid-product__price, .product__price-wrap, .art-rug-product__variant-price, .rk-fixauswahl__card-price') : [];
    containers.forEach(function (container) {
      if (container.closest('[data-rk-hide-market-tax-note]')) return;
      let note = container.querySelector(':scope > .rk-market-tax-note, :scope > [data-rk-market-tax-note]');
      if (!note) {
        note = document.createElement('small');
        note.className = 'rk-market-tax-note';
        note.setAttribute('data-rk-market-tax-note', '');
        container.appendChild(note);
      }
      note.textContent = noteText;
    });
  }

  function updatePurchaseAvailability(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const directPurchase = scope.querySelectorAll ? scope.querySelectorAll('.js-drawer-open-cart, form[action*="/cart/add"], .shopify-payment-button, [data-rk-fixed-add]') : [];
    const hide = current().country_code !== 'CH';
    directPurchase.forEach(function (element) {
      element.classList.toggle('rk-market-direct-purchase-hidden', hide);
      if ('disabled' in element && hide) {
        if (!element.hasAttribute('data-rk-market-was-disabled')) element.setAttribute('data-rk-market-was-disabled', element.disabled ? '1' : '0');
        element.disabled = true;
      } else if ('disabled' in element && !hide && element.hasAttribute('data-rk-market-was-disabled')) {
        element.disabled = element.getAttribute('data-rk-market-was-disabled') === '1';
        element.removeAttribute('data-rk-market-was-disabled');
      }
    });
  }

  function renderAll() {
    if (rendering) return;
    rendering = true;
    exactRegistry.forEach(function (element) {
      if (!element.isConnected) { exactRegistry.delete(element); return; }
      renderExactPriceElement(element);
    });
    registry.forEach(function (node) {
      if (!node.isConnected) { registry.delete(node); return; }
      const desired = transformPriceText(node.__rkMarketSource || '', node.__rkMarketSourceMode || 'net');
      if (node.nodeValue !== desired) node.nodeValue = desired;
    });
    updateTaxNotes(document);
    updatePurchaseAvailability(document);
    updateSelectors();
    document.body && document.body.setAttribute('data-rk-price-country', current().country_code);
    document.documentElement.setAttribute('data-rk-price-currency', current().currency_code);
    document.dispatchEvent(new CustomEvent('rk:prices:refresh', { detail: { market: current() } }));
    rendering = false;
  }

  function selectorMarkets() {
    return markets.slice().sort(function (a, b) {
      function rank(market) {
        if (market.country_code === 'CH') return 0;
        if (market.country_code === 'INTERNATIONAL' || market.is_fallback) return 1;
        return 2;
      }
      const rankA = rank(a);
      const rankB = rank(b);
      if (rankA !== rankB) return rankA - rankB;
      return countryDisplayName(a).localeCompare(countryDisplayName(b), locale(), { sensitivity: 'base' });
    });
  }

  function optionMarkup(market) {
    const currentClass = market.country_code === current().country_code ? ' is-current' : '';
    const name = countryDisplayName(market);
    const suffix = market.is_fallback ? (' · ' + translate('excluding_tax')) : '';
    return '<button type="button" class="rk-price-country-selector__option' + currentClass + '" role="option" aria-selected="' + (market.country_code === current().country_code) + '" data-rk-market-option="' + market.country_code + '" data-rk-search="' + escapeHtml((name + ' ' + market.currency_code).toLowerCase()) + '">' +
      '<span class="rk-price-country-selector__option-name">' + escapeHtml(name) + '</span>' +
      '<span class="rk-price-country-selector__option-currency">' + escapeHtml(market.currency_code + suffix) + '</span>' +
      '</button>';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character];
    });
  }

  function ensureSelectorOptions(selector) {
    if (!selector) return;
    const list = selector.querySelector('[data-rk-market-list]');
    if (!list) return;
    list.innerHTML = selectorMarkets().map(optionMarkup).join('');
    list.setAttribute('data-rk-market-list-rendered', '1');
  }

  function updateSelectors() {
    document.querySelectorAll('[data-rk-market-selector]').forEach(function (selector) {
      const label = selector.querySelector('[data-rk-market-current]');
      const list = selector.querySelector('[data-rk-market-list]');
      const detected = selector.querySelector('[data-rk-market-detected]');
      if (label) label.textContent = countryDisplayName(current()) + ' · ' + current().currency_code;
      if (list && list.getAttribute('data-rk-market-list-rendered') === '1') ensureSelectorOptions(selector);
      if (detected) {
        detected.hidden = !(selectionSource === 'auto' && detectedCountryCode);
        detected.textContent = detected.hidden ? '' : translate('auto_detected') + ': ' + regionDisplayName(detectedCountryCode) + ' · ' + translate('price_country') + ': ' + countryDisplayName(current());
      }
    });
  }

  function closeSelectors(exception) {
    document.querySelectorAll('[data-rk-market-selector].is-open').forEach(function (selector) {
      if (selector === exception) return;
      selector.classList.remove('is-open');
      const panel = selector.querySelector('[data-rk-market-panel]');
      const toggle = selector.querySelector('[data-rk-market-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function setCountry(code, options) {
    const opts = options || {};
    const requested = String(code || '').toUpperCase();
    const next = marketMap.has(requested) ? requested : fallbackMarket.country_code;
    selectedCode = next;
    selectionSource = opts.source || 'manual';
    if (selectionSource === 'auto') detectedCountryCode = requested;
    else if (selectionSource === 'manual') detectedCountryCode = '';
    if (opts.persist !== false) {
      storageSet(STORAGE_KEY, selectedCode);
      storageSet(STORAGE_SOURCE_KEY, selectionSource);
    }
    renderAll();
    window.dispatchEvent(new CustomEvent('ruckstuhl:market-change', { detail: { market: current(), source: selectionSource } }));
    return current();
  }

  async function fetchJson(url, timeoutMs) {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = window.setTimeout(function () { if (controller) controller.abort(); }, timeoutMs || 3500);
    try {
      const response = await fetch(url, {
        credentials: 'omit',
        headers: { 'Accept': 'application/json' },
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return await response.json();
    } finally {
      window.clearTimeout(timer);
    }
  }

  function detectedCodeFromPayload(payload) {
    if (!payload || typeof payload !== 'object') return '';
    const code = payload.country || payload.country_code || payload.countryCode ||
      (payload.detected_values && payload.detected_values.country && (payload.detected_values.country.handle || payload.detected_values.country.code)) ||
      (payload.suggestions && payload.suggestions[0] && payload.suggestions[0].parts && payload.suggestions[0].parts.country && payload.suggestions[0].parts.country.handle);
    return /^[A-Za-z]{2}$/.test(String(code || '')) ? String(code).toUpperCase() : '';
  }

  async function detectCountry() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    try {
      const shopifyPayload = await fetchJson(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', 3000);
      const shopifyCode = detectedCodeFromPayload(shopifyPayload);
      if (shopifyCode) return shopifyCode;
    } catch (error) {}
    if (!EXTERNAL_GEO_FALLBACK || !EXTERNAL_GEO_ENDPOINT) return '';
    try {
      return detectedCodeFromPayload(await fetchJson(EXTERNAL_GEO_ENDPOINT, 3500));
    } catch (error) {
      return '';
    }
  }

  async function autoDetectInitialCountry() {
    if (!AUTO_DETECT || storedCode || selectionSource === 'manual') return;
    const code = await detectCountry();
    if (!code) return;
    setCountry(marketMap.has(code) ? code : fallbackMarket.country_code, { source: 'auto', persist: true });
  }

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-rk-market-toggle]');
    if (toggle) {
      const selector = toggle.closest('[data-rk-market-selector]');
      const panel = selector && selector.querySelector('[data-rk-market-panel]');
      const opening = selector && !selector.classList.contains('is-open');
      closeSelectors(selector);
      if (selector && panel) {
        selector.classList.toggle('is-open', opening);
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', String(opening));
        if (opening) {
          ensureSelectorOptions(selector);
          const search = selector.querySelector('[data-rk-market-search]');
          if (search) { search.value = ''; window.setTimeout(function () { search.focus(); }, 10); }
          selector.querySelectorAll('[data-rk-market-option]').forEach(function (option) { option.hidden = false; });
        }
      }
      event.preventDefault();
      return;
    }

    const option = event.target.closest('[data-rk-market-option]');
    if (option) {
      setCountry(option.getAttribute('data-rk-market-option'), { source: 'manual', persist: true });
      closeSelectors();
      event.preventDefault();
      return;
    }

    if (!event.target.closest('[data-rk-market-selector]')) closeSelectors();
  });

  document.addEventListener('input', function (event) {
    const search = event.target.closest('[data-rk-market-search]');
    if (!search) return;
    const query = String(search.value || '').trim().toLowerCase();
    const selector = search.closest('[data-rk-market-selector]');
    selector && selector.querySelectorAll('[data-rk-market-option]').forEach(function (option) {
      option.hidden = !!(query && String(option.getAttribute('data-rk-search') || '').indexOf(query) === -1);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeSelectors();
  });

  const observer = new MutationObserver(function (mutations) {
    if (rendering) return;
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') registerTextNode(mutation.target);
      mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) registerTextNode(node);
        else if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      });
    });
  });

  window.RuckstuhlMarket = {
    version: '1.7.0',
    metaobjectType: String(data.metaobject_type || ''),
    dataSource: marketDataSource,
    baseCurrency: BASE_CURRENCY,
    baseVatRate: BASE_VAT_RATE,
    markets: markets,
    current: current,
    countryCode: function () { return current().country_code; },
    countryName: function () { return countryDisplayName(current()); },
    currency: function () { return current().currency_code; },
    taxIncluded: function () { return includesTax(current()); },
    taxText: function () { return taxText(current()); },
    priceText: recommendedPriceText,
    dealerText: dealerText,
    priceSuffix: function () { return priceSuffix(current()); },
    isSwitzerland: function () { return current().country_code === 'CH'; },
    convertNet: convertNet,
    convertNetExclusive: convertNetExclusive,
    convertBaseGross: convertBaseGross,
    formatAmount: formatAmount,
    formatNet: formatNet,
    formatGrossChf: formatGrossChf,
    localizeText: function (text, sourceMode) { return transformPriceText(text, sourceMode || 'net'); },
    translate: translate,
    setCountry: setCountry,
    detectCountry: detectCountry,
    refresh: function () { if (document.body) scan(document.body); renderAll(); }
  };

  function init() {
    updateSelectors();
    document.body && document.body.setAttribute('data-rk-price-country', current().country_code);
    document.documentElement.setAttribute('data-rk-price-currency', current().currency_code);
    const shouldObservePrices = OBSERVE_PRICES || !!document.querySelector(priceRootSelector);
    if (shouldObservePrices && document.body) {
      scan(document.body);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      document.addEventListener('shopify:section:load', function (event) { scan(event.target); renderAll(); });
    }
    window.dispatchEvent(new CustomEvent('ruckstuhl:market-ready', { detail: { market: current(), source: selectionSource } }));
    autoDetectInitialCountry();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
